import { render, staticRenderFns } from "./UsuariosIndex.vue?vue&type=template&id=646c0164&scoped=true&"
import script from "./UsuariosIndex.vue?vue&type=script&lang=js&"
export * from "./UsuariosIndex.vue?vue&type=script&lang=js&"
import style0 from "./UsuariosIndex.vue?vue&type=style&index=0&id=646c0164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646c0164",
  null
  
)

export default component.exports